/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Reference_Get_LeadInputs */

const en_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You get back.`)
};

const zh_hans1_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你收到。`)
};

const pt_br2_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você recebe.`)
};

const es_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibes.`)
};

const fr_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous recevez.`)
};

const de_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bekommst zurück.`)
};

const ru_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы получаете.`)
};

const it_endpoint_reference_get_lead = /** @type {(inputs: Endpoint_Reference_Get_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ricevi.`)
};

/**
* | output |
* | --- |
* | "You get back." |
*
* @param {Endpoint_Reference_Get_LeadInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_reference_get_lead = /** @type {((inputs?: Endpoint_Reference_Get_LeadInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Reference_Get_LeadInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_reference_get_lead(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_reference_get_lead(inputs)
	if (locale === "es") return es_endpoint_reference_get_lead(inputs)
	if (locale === "fr") return fr_endpoint_reference_get_lead(inputs)
	if (locale === "de") return de_endpoint_reference_get_lead(inputs)
	if (locale === "ru") return ru_endpoint_reference_get_lead(inputs)
	if (locale === "it") return it_endpoint_reference_get_lead(inputs)
	return en_endpoint_reference_get_lead(inputs)
});